import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

export function Produtos() {
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [products, setProducts] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = products.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = products.filter((employee: any) => {
        return (
            employee.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            employee.id.toString().includes(searchQuery)
        );
    });

    const [show, setShow] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const handleClose = () => setShow(false);

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }

    const handleConfirm = async () => {
        try {
            await api.delete(`empresas/deletar/${idSelected}`);
            const response = await api.get('empresas')
            setProducts(response.data);
            setAlert({ show: true, message: 'Item excluído com sucesso!', variant: 'success' });
        } catch (error) {
            console.error("Erro ao tentar excluir:", error);
            setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
        }
        handleClose();
    };

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadProducts = async (companyId: any) => {
        try {
            const response = await api.get('produtos');
            
            const sortedProducts = response.data.sort((a: any, b: any) => {
                if (a.tipo < b.tipo) return -1;
                if (a.tipo > b.tipo) return 1;
                return 0;
            });
            setProducts(sortedProducts);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadProducts(selectedCompany);
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleStatusChange = async (employeeId: any, currentStatus: any) => {
        try {
            if (currentStatus === 1) {
                await api.post(`produtos/ativar/${employeeId}`);
            } else {
                await api.post(`produtos/desativar/${employeeId}`);
            }
            loadProducts(selectedCompany);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleConfirm}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Produtos" />
                        <Col md={8}>
                            <Button className='newbutton' href={`produtos/cadastrar`}><FillPlus /> Novo Produto</Button>
                        </Col>
                        <Col md={4}>
                            <Search placeHolder="Procure pelo nome" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(products.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead className="table-row-produtos">
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Tipo</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Item</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Funções</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Preço</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentFilteredEmployees.length > 0 ? (
                                                currentFilteredEmployees.map((employee: any) => (
                                                    <React.Fragment key={employee.id}>
                                                        <tr className="table-row-produtos" style={{ textAlign: 'center' }}>
                                                            <td className={`${employee.desativado == false ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.tipo}</td>
                                                            <td className={`${employee.desativado == false ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.nome}</td>
                                                            <td className={`${employee.desativado === false ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {employee.produtos_itens.map((item: any, index: number) => (
                                                                    <div key={index}>
                                                                        {item.nome}
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td className={`${employee.desativado == false ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.quantidade}</td>
                                                            <td className={`${employee.desativado == false ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>R$ {employee.preco.toFixed(2)}</td>
                                                            <td className='action-functions' style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid lightgray', borderRight: '1px solid lightgray', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                <Button variant='outline-main' href={`produtos/editar/${employee.id}`}>Editar</Button>
                                                                <Button
                                                                    variant={`${employee.desativado == false ? 'outline-danger' : 'outline-success'}`}
                                                                    onClick={() => handleStatusChange(employee.id, employee.desativado)}>
                                                                    {employee.desativado == false ? 'Desativar' : 'Ativar'}
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}